import { useMutation, useQueryClient } from '@tanstack/react-query';
import { subscriptionService } from '../../../services/subscription';
import { toast } from 'react-toastify';
import { useTranslation } from '@hooks/useTranslation';

interface AssignPlanParams {
  organizationId: string;
  planId: string;
  billingPeriod?: string;
}

export const useAssignPlanToOrganization = () => {
  const tActionMessages = useTranslation('actionMessages');
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ organizationId, planId, billingPeriod }: AssignPlanParams) =>
      subscriptionService.assignPlanToOrganization(
        organizationId,
        planId,
        billingPeriod,
      ),
    onSuccess: () => {
      // Invalidate organizations query to refresh the table
      queryClient.invalidateQueries({ queryKey: ['organizations'] });
      toast.success(tActionMessages.planAssignedSuccessfully);
    },
    onError: (error: any) => {
      toast.error(
        error?.response?.errors?.[0]?.message || tActionMessages.failedToAssignPlan,
      );
    },
  });
};
